import createSagaMiddleware from 'redux-saga';
import { createStore, applyMiddleware, compose } from 'redux';

import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

import { AQA_KEY, DEV_KEY } from 'constants/dev';

import { isProd } from 'helpers/utils';

import sagas from './redux/sagas';
import rootReducer from './redux/rootReducer';

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

export default function configureStore() {
    const composeEnhancers = (!isProd() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

    const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(sagaMiddleware, thunk)));

    const persistor = persistStore(store);

    const urlParams = new URLSearchParams(window.location.search);
    const refParams = urlParams.get(DEV_KEY);

    if (refParams === AQA_KEY || localStorage.getItem(DEV_KEY)) {
        localStorage.setItem(DEV_KEY, AQA_KEY);

        window['__getState'] = () => store.getState();
    }

    sagaMiddleware.run(sagas);

    return { store, persistor };
}
